import React, { useCallback, useState } from 'react';
import styles from './bomListTable.module.css';
import { Downarrow, EditPart, EditPartWhite, Leaf, Paginationleft, Paginationright, Pdf, trash, Uparrow } from '../../../../Svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAlterProduct, getAlterProductsThunk, setSelectedProducts } from '../../../redux/bomSlice';
import { setLoginpopup } from '../../../redux/customerSlice';
import { toast } from 'react-toastify';
import { stripHtmlTags } from '../../../utils/utils';

const BomListTable = ({ products, handleCheckboxChange, addtoCart, quantities, cartLoading, scheduleLoading, handleQuantityChange, handleSelectAlternate, editingProduct, handleSubmit, newPartNumber, addMoreData, setNewPartNumber, handleEditClick, setProductData, productData, setShowLogin, isLoggedin, dropdownRef, handleDelete, addSingleProductsToCart }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [expandedProducts, setExpandedProducts] = useState({});
    const [expandedaltProducts, setExpandedaltProducts] = useState({});
    const { alterLoading, alterProducts, selectedProducts } = useSelector((state) => state.bom)
    const altProd = alterProducts?.alternateProducts || []
    const productnumber = alterProducts?.productnumber || []
    const [enquiryData, setEnquiryData] = useState([])
    const [newInput, setNewInput] = useState('')
    const isAnyProductSelected = selectedProducts.length > 0;

    const [quantityErrors, setQuantityErrors] = useState({});

    // useEffect(() => {
    //     if (products.length > 0) {
    //         handleSelectAll(products, true)
    //     }
    // }, [products.length])

    const validateQuantity = (productNumber, value) => {
        const product = products?.find(p => p.productNumber === productNumber);
        if (!product?.status) return false;

        const numValue = Number(value);

        if (value === '' || isNaN(numValue)) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Please enter a valid number' }));
            return false;
        }

        if (numValue <= 0) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Quantity must be greater than 0' }));
            return false;
        }

        setQuantityErrors(prev => ({ ...prev, [productNumber]: '' }));
        return true;
    };
    const handleQuantityInputChange = (productNumber, value) => {
        // Update the quantity immediately
        handleQuantityChange(productNumber, value);
        // Validate the quantity
        validateQuantity(productNumber, value);
    };

    const isQuantityValid = (productNumber) => {
        const product = products?.find(p => p.productNumber === productNumber);
        if (!product?.status) return false;

        const quantity = product?.quantity;
        return !isNaN(Number(quantity)) && Number(quantity) > 0;
    };

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };

    const toggleAltShowAll = (productId) => {
        setExpandedaltProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };

    const searchAlter = (part) => {
        dispatch(getAlterProductsThunk(`?productNumber=${part}`))
    }



    const handleChange = (product, e) => {
        handleCheckboxChange(product?.productNumber, e.target.checked)
        const isExist = selectedProducts.find(i => i?.productNumber == product?.productNumber)
        if (isExist) {
            const filter = selectedProducts?.filter((i) => i?.productNumber !== product?.productNumber)
            return dispatch(setSelectedProducts(filter))
        }
        const data = [...selectedProducts, product]
        dispatch(setSelectedProducts(data))
    }

    // Add this function to validate all selected products before adding to cart
    const validateSelectedProducts = () => {
        const invalidProducts = selectedProducts.filter(product => {
            const quantity = product.quantity;
            return !quantity || isNaN(Number(quantity)) || Number(quantity) <= 0;
        });

        if (invalidProducts.length > 0) {
            toast.error('Please enter valid quantities for all selected products');
            return false;
        }

        const outOfStockProducts = selectedProducts.filter(product => {
            const availQty = product?.product?.inventory?.qtyAvailable ?? product?.inventory?.qtyAvailable ?? product?.qtyAvailable ?? product?.stock ?? 0;
            const isOutOfStock = product?.status === 'OUT OF STOCK' || availQty <= 0;
            const quantity = Number(product.quantity || 0);
            return isOutOfStock || quantity > availQty;
        });

        if (outOfStockProducts.length > 0) {
            toast.error('One or more selected products are out of stock or exceed available quantity');
            return false;
        }

        return true;
    };

    // Modify the addtoCart handler to include validation
    const handleAddToCart = (type) => {
        if (!validateSelectedProducts()) {
            return; // Don't proceed if validation fails
        }
        addtoCart(type, '');
    };

    const handleSelectAll = useCallback((products, checked) => {
        if (checked) {
            dispatch(setSelectedProducts(products))
        } else {
            dispatch(setSelectedProducts([]))
        }
    }, [products.length]);

    // const handleSelectAll = (products, checked) => {
    //     if (checked) {
    //         dispatch(setSelectedProducts(products))
    //     }
    // }

    return (
        <>
            <div className={styles.sortedTable} style={{ flexDirection: "column" }}>
                <div style={{ display: "flex", gap: 5, alignItems: "center", padding: "0px 20px 0px 20px" }}>
                    <input type="checkbox"
                        onChange={(e) =>
                            handleSelectAll(products, e.target.checked)
                        }
                        checked={selectedProducts?.length === products?.length}
                    />
                    Select All | {selectedProducts?.length} Selected
                </div>
                <div className={styles.productTableContainer}>

                    <table className={styles.productTable} style={{ background: '#F1F1F1' }}>
                        <thead className={styles.productTableHead}>
                            <tr>
                                <th className={styles.compare}>#</th>
                                <th className={styles.dataSheet}>Data sheet</th>
                                <th className={styles.partNumber}>
                                    <div className={styles.headerWithFilter}>
                                        <span>Part </span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.manufacturer}>
                                    <div className={styles.headerWithFilter} style={{ justifyContent: 'center' }}>
                                        <span>Manufacturer</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.stock}>
                                    <div className={styles.headerWithFilter} style={{ justifyContent: 'center' }}>
                                        <span>Available Stock</span>
                                        <div className={styles.sortIcons}>
                                            <Uparrow />
                                            <Downarrow />
                                        </div>
                                    </div>
                                </th>
                                <th className={styles.unitPrice} style={{ textAlign: 'center' }}>Unit Price</th>
                                <th className={styles.requiredQuantity} style={{ textAlign: 'center' }}>Required Quantity</th>

                            </tr>
                        </thead>
                        <tbody >
                            <>
                                {products?.filter(p => {
                                    const pNum = p?.productNumber ? String(p.productNumber).trim().toLowerCase() : '';
                                    return pNum && pNum !== 'id' && pNum !== '-';
                                })?.map((product, index) => {
                                    return (
                                        <>
                                            <tr key={index} style={{ backgroundColor: product?.productNumber == productnumber ? '#F1F1F1' : '#ffffff' }}>
                                                <td className={`${styles.compare}  ${styles.tdBorder}`} >
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                        <input type="checkbox"
                                                            // value={quantities[product?.productNumber]}
                                                            checked={selectedProducts?.find(i => i?.productNumber === product?.productNumber)}
                                                            onChange={(e) =>
                                                                handleChange(product, e)
                                                            }
                                                        />
                                                        <div style={{ color: !product?.status ? '#e11d48' : '#1e293b' }}>
                                                            {index + 1}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className={`${styles.dataSheet}  ${styles.tdBorder}`}>

                                                    {product?.status ?
                                                        <div className={styles.dataCol}>
                                                            <a href={product?.product?.productOverview?.datasheetUrl[0]} target='_blank'>
                                                                <Pdf />
                                                            </a>
                                                            <Leaf />
                                                        </div>
                                                        :
                                                        <div style={{ color: '#94a3b8' }}>-</div>
                                                    }
                                                </td>
                                                <td className={`${styles.partNumber}  ${styles.tdBorder}`}>

                                                    <div className={styles.dataRow} >
                                                        {product?.status ?
                                                            <>
                                                                <img src={product?.product?.assets?.featuredImage[0]} style={{ width: 40, height: 40 }} />
                                                                <div className={styles.dataCol} >
                                                                    {editingProduct === product.productNumber ?
                                                                        <div style={{ display: 'flex' }} ref={dropdownRef}>
                                                                            <input
                                                                                type="text"
                                                                                className={styles.dataInput}
                                                                                value={newPartNumber}
                                                                                onChange={(e) => setNewPartNumber(e.target.value)}
                                                                            />

                                                                            <button onClick={handleSubmit} className={styles.addButton} style={{ borderRadius: 5, height: 38, width: 80, textAlign: 'center', background: '#512DA8', color: 'white' }}>Submit</button>

                                                                        </div>
                                                                        :
                                                                        <div className={styles.displayFlex} >
                                                                            <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${product?.productNumber}`)} style={{ cursor: 'pointer' }}>{product?.productNumber}</div>
                                                                            <div onClick={() => handleEditClick(product?.productNumber)} style={{ cursor: 'pointer' }}>
                                                                                <EditPart />
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    <div>{stripHtmlTags(product?.product?.productOverview?.description?.[0] || product?.product?.description)}</div>
                                                                    <div style={{ display: 'flex', gap: 10 }}>
                                                                        <div disabled={alterLoading} onClick={() => searchAlter(product?.productNumber)} style={{ textDecoration: 'underline', color: '#512DA8', cursor: 'pointer' }}>Search Alternate</div>
                                                                        {alterLoading &&
                                                                            <div>
                                                                                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 25, height: 25 }} />
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <div >
                                                                {editingProduct === product.productNumber ?
                                                                    <div style={{ display: 'flex' }} ref={dropdownRef}>
                                                                        <input
                                                                            type="text"
                                                                            className={styles.dataInput}
                                                                            value={newPartNumber}
                                                                            onChange={(e) => setNewPartNumber(e.target.value)}
                                                                        />

                                                                        <button onClick={handleSubmit} className={styles.addButton} style={{ borderRadius: 5, height: 38, width: 80, textAlign: 'center', background: '#512DA8', color: 'white' }}>Submit</button>

                                                                    </div>
                                                                    :
                                                                    <div className={styles.displayFlex} >
                                                                        <div style={{ background: '#f1f5f9', border: '1px solid #cbd5e1', borderRadius: 4, paddingLeft: 10, paddingRight: 20, paddingBottom: 7, paddingTop: 7, color: '#1e293b', fontSize: 12, fontWeight: 600 }}>{product?.productNumber}</div>
                                                                        <div onClick={() => handleEditClick(product?.productNumber)} style={{ cursor: 'pointer' }}>
                                                                            <EditPart />
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div style={{ color: '#e11d48', fontSize: 12, fontWeight: 500, marginTop: 4 }}>Exact match not found.</div>
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                                <td className={`${styles.manufacturer}  ${styles.tdBorder}`} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                    {product?.status ?
                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 70, width: '100%' }}>
                                                            <a href={product.manufacturerUrl} className={styles.manufacturer} style={{ display: 'inline-block', textAlign: 'center' }}>
                                                                <div className={styles.dataColorChange} style={{ textAlign: 'center' }}> {product?.product?.productOverview?.manufacturer[0]?.name}</div>
                                                            </a>
                                                        </div>
                                                        :
                                                        <div style={{ color: '#94a3b8', textAlign: 'center' }}>-</div>
                                                    }
                                                </td>



                                                <td className={`${styles.stock}  ${styles.tdBorder}`} style={{ verticalAlign: 'top', alignContent: 'flex-start' }}>
                                                    {product?.status ?
                                                        <>

                                                            <div style={{ color: '#222222', fontWeight: 700 }}>
                                                                {product?.product?.inventory?.qtyAvailable}
                                                            </div>
                                                            <div className={styles.dataMargin}>{product?.product?.inventory?.qtyAvailable > 0 ? "in stock" : "out of stock"}</div>
                                                            {product?.product?.inventory?.factoryStock ?
                                                                <>

                                                                    <div style={{ color: '#222222', fontWeight: 700 }}>
                                                                        {product?.product?.inventory?.factoryStock}
                                                                    </div>
                                                                    <div className={styles.dataMargin}>factoryStock</div>
                                                                </>
                                                                : null}
                                                            <div>CanShip Immediately: <span style={{ color: '#222222', fontWeight: 700 }}>{product?.product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</span> </div>
                                                        </>
                                                        :
                                                        <div style={{ color: '#94a3b8' }}>-</div>
                                                    }
                                                </td>
                                                <td className={`${styles.unitPrice}  ${styles.tdBorder}`} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                    {product?.status ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 70, width: '100%', textAlign: 'center' }}>
                                                            {product?.product?.quantityTable
                                                                ?.slice(
                                                                    0,
                                                                    expandedProducts[product?.product?._id]
                                                                        ? product?.product?.quantityTable?.length
                                                                        : 2
                                                                )
                                                                .map((i, index) => (
                                                                    <div key={index} className={styles.dataMargin} style={{ textAlign: 'center' }}>
                                                                        {i?.breakQty}: <span style={{ color: '#222222', fontWeight: 700 }}>₹{i?.unitPrice}</span>
                                                                        <div style={{ textAlign: 'center' }}>
                                                                            {i?.packaging}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            {product?.product?.quantityTable?.length > 2 && (
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault(); // Prevent page reload
                                                                        toggleShowAll(product?.product?._id);
                                                                    }}
                                                                    style={{ textAlign: 'center' }}
                                                                >
                                                                    <div className={styles.dataColorChange} style={{ textAlign: 'center' }}>
                                                                        {expandedProducts[product?.product?._id]
                                                                            ? "Show Less"
                                                                            : "More Inventory"}
                                                                    </div>
                                                                </a>
                                                            )}
                                                        </div>
                                                        :
                                                        <div style={{ color: '#94a3b8', textAlign: 'center' }}>-</div>
                                                    }
                                                </td>
                                                <td className={`${styles.requiredQuantity}  ${styles.tdBorder}`}>
                                                    {product?.status ?
                                                        <>
                                                            <input
                                                                type="text"
                                                                placeholder="Enter qty"
                                                                className={styles.dataInput}
                                                                // value={quantities[product?.productNumber] || ""}
                                                                value={product?.quantity || ""}
                                                                onChange={(e) =>
                                                                    handleQuantityInputChange(product?.productNumber, e.target.value)
                                                                }
                                                            />
                                                            <div className={styles.dataMargin}>Min {product?.product?.inventory?.minimumMultiplier || 1}</div>
                                                            <div className={styles.dataMargin}>
                                                                SPQ: {product?.product?.inventory?.minimumMultiplier || 1}
                                                            </div>
                                                            {quantityErrors[product?.productNumber] && (
                                                                <div className={styles.errorText}>
                                                                    {quantityErrors[product?.productNumber]}
                                                                </div>
                                                            )}

                                                            <div className={styles.dataCol}>
                                                                <button
                                                                    className={styles.addButton}
                                                                    // disabled={!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0}
                                                                    onClick={() => addSingleProductsToCart('cart', product)}
                                                                    disabled={!isQuantityValid(product?.productNumber)}
                                                                    // style={{ cursor: 'pointer', color: (!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0) ? '#a284e6' : '#512DA8' }}
                                                                    style={{ cursor: 'pointer', color: isQuantityValid(product?.productNumber) ? '#512DA8' : '#a284e6' }}
                                                                >
                                                                    {cartLoading[product?.productNumber] ? 'Please wait...' : '+ Add to cart'}
                                                                </button>
                                                                <button
                                                                    className={styles.scheduleButton}
                                                                    // disabled={!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0}
                                                                    disabled={!isQuantityValid(product?.productNumber)}
                                                                    onClick={() => addSingleProductsToCart('schedule', product)}
                                                                    // style={{ cursor: 'pointer', color: (!quantities[product?.productNumber] || quantities[product?.productNumber] <= 0) ? '#a284e6' : '#512DA8' }}
                                                                    style={{ cursor: 'pointer', color: isQuantityValid(product?.productNumber) ? '#512DA8' : '#a284e6' }}

                                                                >
                                                                    {scheduleLoading[product?.productNumber] ? 'Please wait...' : '+ Add to schedule'}
                                                                </button>
                                                            </div>
                                                        </>
                                                        :

                                                        <>
                                                            <input
                                                                type="text"
                                                                className={styles.dataInput}
                                                                style={{ background: 'white' }} value={product?.quantity || ""}
                                                                onChange={(e) =>
                                                                    handleQuantityInputChange(product?.productNumber, e.target.value)
                                                                }
                                                            />
                                                            <div style={{ color: '#94a3b8' }}>-</div>
                                                        </>
                                                    }
                                                </td>
                                            </tr>
                                            {product?.productNumber == productnumber &&
                                                <>
                                                    {altProd?.length > 0 ?
                                                        <>
                                                            <div style={{ paddingLeft: 4 }}>
                                                                My Alternate
                                                            </div>
                                                            {altProd?.map((altpro, index) => (
                                                                <>
                                                                    <tr style={{ marginTop: 10, display: 'flex', width: '100%', gap: 10, alignItems: 'center' }}>

                                                                        <div
                                                                            key={altpro.productNumber}
                                                                            style={{ textDecoration: 'underline', color: '#512DA8', cursor: 'pointer', paddingLeft: 20 }}
                                                                            onClick={() => handleSelectAlternate(product?.productNumber, altpro?.productOverview?.productNumber[0])}
                                                                        >
                                                                            Replace Primary
                                                                        </div>
                                                                        <div onClick={() => dispatch(deleteAlterProduct(altpro?.productOverview?.productNumber[0]))} style={{ cursor: 'pointer' }}>
                                                                            {trash()}
                                                                        </div>
                                                                    </tr>
                                                                    <tr key={index} style={{ borderBottomWidth: 0.8, borderTop: 0, borderLeft: 0, borderRight: 0, borderColor: '#d9d9d9', borderStyle: 'solid' }}>

                                                                        <td className={`${styles.compare}  `} style={{ border: 'none' }}></td>
                                                                        <td className={`${styles.dataSheet} `}>

                                                                            <div className={styles.dataCol}>
                                                                                <a href={altpro?.productOverview?.datasheetUrl[0]} target='_blank'>
                                                                                    <Pdf />
                                                                                </a>
                                                                                <Leaf />
                                                                            </div>

                                                                        </td>
                                                                        <td className={`${styles.partNumber} `}>

                                                                            <div className={styles.dataRow}>

                                                                                <img src={altpro?.assets?.featuredImage[0]} style={{ width: 40, height: 40 }} />
                                                                                <div className={styles.dataCol}>
                                                                                    <div className={styles.displayFlex}>
                                                                                        <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${altpro?.productOverview?.productNumber[0]}`)} style={{ cursor: 'pointer' }}>{altpro?.productOverview?.productNumber[0]}</div>
                                                                                        {/* <EditPart /> */}
                                                                                    </div>
                                                                                    <div>{stripHtmlTags(altpro?.productOverview?.description?.[0] || altpro?.description)}</div>

                                                                                </div>

                                                                            </div>
                                                                        </td>
                                                                        <td className={`${styles.manufacturer}`} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 70, width: '100%' }}>
                                                                                <a href={product.manufacturerUrl} className={styles.manufacturer} style={{ display: 'inline-block', textAlign: 'center' }}>
                                                                                    <div className={styles.dataColorChange} style={{ textAlign: 'center' }}> {altpro?.productOverview?.manufacturer[0]?.name}</div>
                                                                                </a>
                                                                            </div>
                                                                        </td>



                                                                        <td className={`${styles.stock}`} style={{ verticalAlign: 'top', alignContent: 'flex-start' }}>
                                                                            <>

                                                                                <div style={{ color: '#222222', fontWeight: 700 }}>
                                                                                    {altpro?.inventory?.qtyAvailable}
                                                                                </div>
                                                                                <div className={styles.dataMargin}>{altpro?.inventory?.qtyAvailable > 0 ? "in stock" : "out of stock"}</div>
                                                                                {altpro?.inventory?.factoryStock ?
                                                                                    <>
                                                                                        <div style={{ color: '#222222', fontWeight: 700 }}>
                                                                                            {altpro?.inventory?.factoryStock}
                                                                                        </div>
                                                                                        <div className={styles.dataMargin}>factoryStock</div>
                                                                                    </>
                                                                                    : null}
                                                                                <div>CanShip Immediately: <span style={{ color: '#222222', fontWeight: 700 }}>{altpro?.inventory?.canShipImmediately ? 'YES' : 'NO'}</span> </div>
                                                                            </>

                                                                        </td>
                                                                        <td className={`${styles.unitPrice} `} style={{ textAlign: 'center', verticalAlign: 'middle', alignContent: 'center' }}>
                                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', minHeight: 70, width: '100%', textAlign: 'center' }}>
                                                                                {altpro?.quantityTable
                                                                                    ?.slice(
                                                                                        0,
                                                                                        expandedaltProducts[altpro?._id]
                                                                                            ? altProd?.quantityTable?.length
                                                                                            : 2
                                                                                    )
                                                                                    .map((i, index) => (
                                                                                        <div key={index} className={styles.dataMargin} style={{ textAlign: 'center' }}>
                                                                                            {i?.breakQty}: <span style={{ color: '#222222', fontWeight: 700 }}>₹{i?.unitPrice}</span>
                                                                                            <div style={{ textAlign: 'center' }}>
                                                                                                {i?.packaging}
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                {altpro?.quantityTable?.length > 2 && (
                                                                                    <a
                                                                                        href="#"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault(); // Prevent page reload
                                                                                            toggleAltShowAll(altpro?._id);
                                                                                        }}
                                                                                        style={{ textAlign: 'center' }}
                                                                                    >
                                                                                        <div className={styles.dataColorChange} style={{ textAlign: 'center' }}>
                                                                                            {expandedaltProducts[altpro?._id]
                                                                                                ? "Show Less"
                                                                                                : "More Inventory"}
                                                                                        </div>
                                                                                    </a>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        {/* <td className={`${styles.requiredQuantity} `}>
                                                                        <>
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Enter qty"
                                                                                className={styles.dataInput}
                                                                                value={quantities[product?._id] || ""}
                                                                                onChange={(e) =>
                                                                                    handleQuantityChange(product?._id, e.target.value)
                                                                                }
                                                                            />
                                                                            <div className={styles.dataMargin}>Min 1</div>
                                                                            <div className={styles.dataCol}>
                                                                                <button
                                                                                    className={styles.addButton}
                                                                                    disabled={!quantities[product?._id] || quantities[product?._id] <= 0}
                                                                                    onClick={() => addtoCart('cart', product?._id)}
                                                                                    style={{ cursor: 'pointer', color: (!quantities[product?._id] || quantities[product?._id] <= 0) ? '#a284e6' : '#512DA8' }}
                                                                                >
                                                                                    {cartLoading[product?._id] ? 'Please wait...' : '+ Add to cart'}
                                                                                </button>
                                                                                <button
                                                                                    className={styles.scheduleButton}
                                                                                    disabled={!quantities[product?._id] || quantities[product?._id] <= 0}
                                                                                    onClick={() => addtoCart('schedule', product?._id)}
                                                                                    style={{ cursor: 'pointer', color: (!quantities[product?._id] || quantities[product?._id] <= 0) ? '#a284e6' : '#512DA8' }}

                                                                                >
                                                                                    {scheduleLoading[product?._id] ? 'Please wait...' : '+ Add to schedule'}
                                                                                </button>
                                                                            </div>
                                                                        </>

                                                                    </td> */}
                                                                    </tr>
                                                                </>
                                                            ))
                                                            }
                                                        </>
                                                        :
                                                        <tr>
                                                            {null}
                                                        </tr>
                                                    }
                                                </>
                                            }
                                        </>
                                    )
                                })}

                            </>
                        </tbody>
                    </table>
                    <div style={{ marginTop: '20px' }}>
                        <form action="" onSubmit={(e) => addMoreData(newInput, e)}>
                            <input type='text' placeholder='Add Part number' className={styles.dataInput} onChange={(e) => setNewInput(e.target.value)} />
                            {/* <span>Or</span>
                            <button className={styles.compareBtn} >Bulk Add</button> */}
                        </form>
                    </div>
                </div>
            </div>
            {isAnyProductSelected &&
                <div className={styles.mainBtns}>
                    <div>
                        <button className={styles.quoteBtn} onClick={handleDelete}>Delete</button>
                    </div>
                    <div className={styles.listingBtns}>
                        <button className={styles.quoteBtn} onClick={() => {
                            if (!isLoggedin) {
                                dispatch(setLoginpopup(true))
                                return setShowLogin(true)
                            }
                            navigate(`/quoteRequest`, { state: { data: selectedProducts } })

                        }}
                        >Quote Request</button>
                        <div className={styles.divide}></div>
                        <button
                            className={styles.addBtn}
                            onClick={() => handleAddToCart('cart')}
                        >
                            Add to Cart
                        </button>
                        <button
                            className={styles.addBtn}
                            onClick={() => handleAddToCart('schedule')}
                        >
                            Add to schedule
                        </button>
                    </div>
                </div>
            }
        </>
    );
};

export default BomListTable;
